import CandidatesContainer from './candidates_container';

const Candidates = CandidatesContainer;
export default Candidates;
